module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('navbar', [_c('button', {
    staticClass: "navbar-toggler mobile-sidebar-toggler hidden-lg-up",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.mobileSidebarToggle
    }
  }, [_vm._v("\n      ☰\n    ")]), _vm._v(" "), _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#"
    }
  }), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav hidden-md-down"
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link navbar-toggler sidebar-toggler",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.sidebarToggle
    }
  }, [_vm._v("☰")])]), _vm._v(" "), _c('li', {
    staticClass: "breadcrumb-item"
  }, [_c('span', {
    staticClass: "active"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/'
    }
  }, [_vm._v(_vm._s(_vm.web_texts.header.select_system))]), _vm._v(" "), _c('span', [_vm._v(" | " + _vm._s(_vm.system.name))])], 1)]), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav ml-auto"
  }, [_c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('span', {}, [_vm._v("IDIOMA")])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-center",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.changeLang('cat')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": 'static/img/catalonia.png',
      "height": "21",
      "width": "21"
    }
  }), _vm._v("  CATALÀ")]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.changeLang('es')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": 'static/img/spain.png',
      "height": "21",
      "width": "21"
    }
  }), _vm._v("  ESPAÑOL")])])]), _vm._v("\n       \n      "), _c('dropdown', {
    staticClass: "nav-item",
    attrs: {
      "size": "nav"
    }
  }, [_c('span', {
    attrs: {
      "slot": "button"
    },
    slot: "button"
  }, [_c('img', {
    staticClass: "img-avatar",
    attrs: {
      "src": "static/img/avatars/default_avatar.png",
      "alt": "admin@bootstrapmaster.com"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-md-down"
  }, [_vm._v(_vm._s(_vm.user.name))])]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right",
    attrs: {
      "slot": "dropdown-menu"
    },
    slot: "dropdown-menu"
  }, [_c('div', {
    staticClass: "dropdown-header text-center"
  }, [_c('strong', [_vm._v("Settings")])]), _vm._v(" "), (_vm.$route.name !== '') ? _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": function($event) {
        _vm.$router.push('profile')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.web_texts.header.profile))]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item",
    on: {
      "click": _vm.logout
    }
  }, [_c('i', {
    staticClass: "fa fa-lock"
  }), _vm._v(" " + _vm._s(_vm.web_texts.header.logout))])])]), _vm._v(" "), _c('li', {
    staticClass: "nav-item hidden-md-down"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-939f6bce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header.vue
// module id = 563
// module chunks = 1